import React, { createContext, useCallback, useContext, useState } from 'react';
import { IUser } from 'src/models/interfaces/user';
import authService from 'src/service/auth';

export const AuthContext = createContext({} as {
  login: (email: string, registration: string) => Promise<void>,
  logout: () => void,
  user: IUser | null
});

export const AuthProvider = (props: any) => {
  const [user, setUser] = useState<IUser | null>(null);

  const handleLoadUser = useCallback((user: IUser) => {
    setUser(user);
  }, []);

  authService.updateUser(handleLoadUser);

  if (!user) authService.loadUser();

  const login = useCallback((email: string, registration: string): Promise<void> => {
    return authService.login(email, registration);
  }, []);

  const logout = useCallback((): void => {
    return authService.logout();
  }, []);

  return (
    <AuthContext.Provider value={{ login, logout, user }}>
      {props.children}
    </AuthContext.Provider>
  );
};

const useAuth = () => useContext(AuthContext);
export default useAuth;